import angular from "angular";

angular
    .module('api-common')
    .factory('ApiToken', ApiToken);

ApiToken.$inject = [];

function ApiToken() {
    var expiresAt = null;

    var service = {
        get: get,
        getExpirationDate: getExpirationDate,
        set: set,
        clear: clear,
        isValid: isValid
    };

    return service;

    ///////////////////////////

    function get() {
        return expiresAt ? {expiresAt: expiresAt} : null;
    }

    function getExpirationDate(milliseconds) {
        return new Date((new Date().getTime() + milliseconds * 1000));
    }

    function set(expirationDate) {
        expiresAt = expirationDate;
    }


    function clear() {
        expiresAt = null;
    }

    function isValid() {
        return (expiresAt && new Date().getTime() <= expiresAt.getTime());
    }
}
